export const GET_STAFF_ROLES = 'GET_STAFF_ROLES'
export const GET_STAFF_ROLE = 'GET_STAFF_ROLE'
export const CREATE_STAFF_ROLE = 'CREATE_STAFF_ROLE'
export const UPDATE_STAFF_ROLE = 'UPDATE_STAFF_ROLE'
export const DELETE_STAFF_ROLE = 'DELETE_STAFF_ROLE'
export const BULK_DELETE_STAFF_ROLES = 'BULK_DELETE_STAFF_ROLES'
export const ASSIGN_PERMISSIONS = 'ASSIGN_PERMISSIONS'
export const GET_ASSIGN_PERMISSIONS = 'GET_ASSIGN_PERMISSIONS'
export const GENERATE_STAFF_ROLE_PERMISSION_REPORT = 'GENERATE_STAFF_ROLE_PERMISSION_REPORT'
